import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import { injectIntl } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import Tabs from '../../../../../../../../../components/Tabs'

import Distraints from './components/Distraints'
import Bankrupt from './components/Bankrupt'
import PaymentOrders from './components/PaymentOrders'
import Liens from './components/Liens'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
export default class CompanyAsCreditor extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.locale !== nextProps.locale) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const { id, intl, data, module, block, level, locale, customData } = this.props

        return (
            <div className={cx('block-company-as-creditor')}>
                <Tabs
                    level={level}
                    id={`company-as-creditor-tabs-${id}`}
                    key={`company-as-creditor-tabs-${id}`}
                    tabs={[
                        {
                            // DISTRAINTS
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.distraints` }),
                            content: (
                                <Distraints
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    tableId={`cac-distraints-filter-table-${id}`}
                                    tableSelector={'distraints'}
                                    locked={_.isNil(data?.executions?.active) && _.isNil(data?.executions?.total)}
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'executions.active', 0),
                                },
                                right: {
                                    count: _.get(data, 'executions.total', 0),
                                },
                            },
                            locked: _.isNil(data?.executions?.active) && _.isNil(data?.executions?.total),
                        },
                        {
                            // BANKRUPT
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.bankrupt` }),
                            content: (
                                <Bankrupt
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    tableId={`cac-bankrupt-filter-table-${id}`}
                                    tableSelector={'bankrupt'}
                                    locked={
                                        _.isNil(data?.receivablesFromBankrupt?.active) &&
                                        _.isNil(data?.receivablesFromBankrupt?.total)
                                    }
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'receivablesFromBankrupt.active', 0),
                                },
                                right: {
                                    count: _.get(data, 'receivablesFromBankrupt.total', 0),
                                },
                            },
                            locked:
                                _.isNil(data?.receivablesFromBankrupt?.active) &&
                                _.isNil(data?.receivablesFromBankrupt?.total),
                        },
                        {
                            // PAYMENT ORDERS
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.paymentOrders` }),
                            content: (
                                <PaymentOrders
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    tableId={`cac-payment-orders-filter-table-${id}`}
                                    tableSelector={'paymentOrders'}
                                    locked={_.isNil(data?.paymentOrders?.active)}
                                />
                            ),
                            subtitle: intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfOrders` }),
                            counter: {
                                left: {
                                    count: _.get(data, 'paymentOrders.active', 0),
                                },
                            },
                            locked: _.isNil(data?.paymentOrders?.active),
                        },
                        {
                            // LIENS
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.liens` }),
                            content: (
                                <Liens
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    maxGuarantee={data?.liens?.maxGuarantee?.[0]}
                                    tableId={`cac-liens-filter-table-${id}`}
                                    tableSelector={'liens'}
                                    locked={_.isNil(data?.liens?.total)}
                                />
                            ),
                            subtitle: intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfOrders` }),
                            counter: {
                                left: {
                                    count: _.get(data, 'liens.total', 0),
                                },
                            },
                            locked: _.isNil(data?.liens?.total),
                        },
                    ]}
                />
            </div>
        )
    }
}
